<template>
  <div class="floating-contact-buttons">
    <!-- Facebook 联系按钮 -->
    <a 
      href="https://www.facebook.com/profile.php?id=61577205355724" 
      target="_blank" 
      class="floating-button facebook-button"
      :title="t('facebook')"
    >
      <img src="../assets/facebook.png" :alt="t('facebook')" class="button-icon" />
    </a>
    
    <!-- WhatsApp 联系按钮 -->
    <a 
      href="whatsapp://send?phone=+85266860815" 
      target="_blank" 
      class="floating-button whatsapp-button"
      :title="t('whatsapp')"
    >
      <img src="../assets/whatsapp.png" :alt="t('whatsapp')" class="button-icon" />
    </a>
    
    <!-- Instagram 联系按钮 -->
    <a 
      href="https://www.instagram.com/dr_moto_ev_hk_ltd/" 
      target="_blank" 
      class="floating-button instagram-button"
      :title="t('instagram')"
    >
      <img src="../assets/Instagram.png" :alt="t('instagram')" class="button-icon" />
    </a>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

// 使用i18n获取翻译文本
const { t } = useI18n();
</script>

<style scoped>
/* 修改前 */
.floating-contact-buttons {
    position: fixed;
    top: 65%;
    right: 30px;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    gap: 15px;
    z-index: 9999;
    pointer-events: all;
  }

.floating-button {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.95);
  border: 2px solid #12aa4a;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  text-decoration: none;
  opacity: 0.95;
  backdrop-filter: blur(5px);
}

.floating-button:hover {
  transform: translateY(-5px) scale(1.05);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  opacity: 1;
}

.button-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.floating-button:hover .button-icon {
  transform: scale(1.1);
}

/* 为每个按钮添加独特的悬停效果 */
.facebook-button:hover {
  background-color: #1877F2;
}

.whatsapp-button:hover {
  background-color: #25D366;
}

.instagram-button:hover {
  background-color: #E1306C;
}

/* 平板端响应式样式更新 */
@media (max-width: 768px) {
  .floating-contact-buttons {
    top: 65%;
    right: 20px;
    transform: translateY(-50%);
    gap: 10px;
  }
}

/* 手机端响应式样式更新 */
@media (max-width: 480px) {
  .floating-contact-buttons {
    top: 65%;
    right: 15px;
    transform: translateY(-50%);
  }
}
</style>